<template>
  <div>
    <div class="content">
      <div class="top">融资需求明细</div>
      <div class="from">
        <el-form ref="form" :model="form" :inline="true">
          <!-- <el-form-item label="需求编号">
            <el-input v-model="form.demandNo" clearable style="width: 200px;"></el-input>
          </el-form-item> -->
          <el-form-item label="企业名称">
            <el-input
              style="width: 200px;"
              placeholder="请输入"
              v-model="form.enterpriseName"
            ></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码">
            <el-input
              style="width: 200px;"
              placeholder="请输入"
              v-model="form.enterpriseCode"
            ></el-input>
          </el-form-item>
          <el-form-item label="受理状态">
            <el-select v-model="form.status" clearable style="width:150px">
              <el-option v-for="item in belongAreaArr" :key="item.id" :label="item.label" :value="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryInfo">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tab">
        <el-table :data="applyProList" style="width: 100%">
          <!-- <el-table-column prop="demandNo" :align="'center'" label="需求编号" width="180">
          </el-table-column> -->
          <el-table-column prop="enterpriseName" :align="'center'" label="企业名称" width="250">
          </el-table-column>
          <el-table-column prop="enterpriseCode" :align="'center'" label="统一社会信用代码" width="200">
          </el-table-column>
          <el-table-column prop="releaseDate" :align="'center'" label="申请时间" width="120">
          </el-table-column>
          <el-table-column prop="phone" :align="'center'" label="联系人手机号" width="150">
          </el-table-column>
          <el-table-column prop="purposeLoanAmount" :align="'center'" label="意向贷款金额(万元)" width="200">
          </el-table-column>
          <el-table-column prop="status" :align="'center'" label="受理状态">
          </el-table-column>
          <el-table-column prop="submitType" :align="'center'" label="提交方式" width="120">
          </el-table-column>
          <el-table-column align="center" prop="money" label="操作" v-if="getSourceType === '2'" width="200">
            <template slot-scope="{ row }">
              <el-button @click="detailLook(row)" type="text" v-if="row.status == '未受理'">审核</el-button>
              <!-- <el-button @click="addFk(row)" type="text" >新增放款</el-button> -->
              <el-button @click="fkInformation(row)" type="text" >放款信息</el-button>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="money" label="操作" v-if="getSourceType === '4'" width="200" fixed="right">
            <template slot-scope="{ row }">
              <el-button @click="lookGan(row)" type="text" >查看操作</el-button>
              <el-button @click="addDialogF(row)" type="text" >新增</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next"
            :total="this.total"
          ></el-pagination>
        </div>
      </div>

    </div>
    <el-dialog
      title="放款信息"
      :visible.sync="fkDialog"
      @close="fkDialog = false"
      :close-on-click-modal = "false"
      width="600px"
    >
      <div class="fkDialogClass">
        <div class="fkItem">
          <div>放款金额(万):</div>
          <div class="rightClass">{{ detailForm.purposeLoanAmount }}</div>
        </div>
        <div class="fkItem">
          <div>放款利率：</div>
          <div class="rightClass">{{ detailForm.loanRate }}</div>
        </div>
        <div class="fkItem">
          <div>放款期限(月):</div>
          <div class="rightClass">{{ detailForm.purposeLoanTerm }}</div>
        </div>
        <div class="fkItem">
          <div>担保方式:</div>
          <div class="rightClass">{{ detailForm.assureStyle }}</div>
        </div>
        <div class="fkItem">
          <div>还款方式:</div>
          <div class="rightClass">{{ detailForm.repayType }}</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="查看操作"
      :visible.sync="ckDialog"
      @close="ckDialog = false"
      :close-on-click-modal = "false"
    >
      <div class="tab2" style="width: 100%;">
        <el-table :data="ckDialogList" style="width: 100%">
          <el-table-column prop="operateContent" :align="'center'" label="操作内容" width="500">
          </el-table-column>
          <el-table-column prop="operator" :align="'center'" label="操作人">
          </el-table-column>
          <el-table-column prop="operateTime" :align="'center'" label="操作时间" width="180">
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange2"
            layout="total, prev, pager, next"
            :page-size="form2.pageSize"
            :total="this.total2"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="新增"
      :visible.sync="addDialog"
      @close="addDialog = false"
      :close-on-click-modal = "false"
      width="600px"
    >
      <div class="fkDialogClass">
        <div class="fkItem">
          <div>操作内容:</div>
          <div class="rightClass">
            <el-input
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 5}"
              placeholder="请输入内容"
              v-model="detailForm2.operateContent"
              style="width: 400px;"
            ></el-input>
          </div>
        </div>
        <div class="btn2">
          <el-button
            class="anniu"
            @click="addDialog = false"
          >取消</el-button>
          <el-button
            @click="submitDialog()"
            type="primary"
            class="anniu"
          >确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { selectDemandListByCondition ,updateStatusById,listByDemandId,save } from '@/api/ydm'
export default {
  name:'FinanceDetail',
  props:{
    getSourceType: String,
  },
  data() {
    return {
      belongAreaArr:[
        {
          id:1,
          label:'已受理'
        },
        {
          id:2,
          label:'未受理'
        }
      ],
      ckDialog:false,//查看操作
      fkDialog:false,
      addDialog:false,//新增
      ckDialogList:[],
      form: {
        demandNo:'', //需求编号
        status:'',//受理状态
        enterpriseName:'', //企业名称
        enterpriseCode:'',//统一社会信用代码
        bankCode:'',//意向银行代码
        page: 1,
        pageSize: 10
      },
      detailForm:{},
      detailForm2:{
        demandId:'',//需求id
        demandNo:'',//需求编号
        operateContent:''//操作内容
      },
      demandId:'',//需求id
      registereFrom: {},
      applyProList: [],
      total: 0,
      total2: 0,
      form2: {
        page: 1,
        pageSize: 5
      }
    };
  },
  mounted(){
    this.getcheckinListList();
  },
  methods: {
    submitDialog(){
      save(this.detailForm2).then(res=>{
        if(res.data.code == 200){
          this.$message.success(res.data.msg)
          this.addDialog = false
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    lookGan(row){
      this.demandId = row.id
      listByDemandId({demandId:row.id,page:1,pageSize:this.form2.pageSize}).then(res=>{
        console.log(res)
        if(res.data.code == 200){
          this.ckDialogList = res.data.data.list
          this.total2 = res.data.data.total
          this.ckDialog = true
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    addDialogF(row){
      this.detailForm2.demandId = row.id
      this.detailForm2.demandNo = row.demandNo
      this.detailForm2.operateContent = ''
      this.addDialog = true
    },
    fanye(){
      listByDemandId({demandId:this.demandId,page:this.form2.page,pageSize:this.form2.pageSize}).then(res=>{
        if(res.data.code == 200){
          this.ckDialogList = res.data.data.list
          this.total2 = res.data.data.total
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    fkInformation(row){
      this.fkDialog = true
      
    },
    detailLook(row){
      this.$confirm(
        `确定要受理吗?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
      .then(async () => {
        updateStatusById({id:row.id}).then(res=>{
          if(res.data.code == 200){
            this.$message.success("受理成功");
            this.getcheckinListList()
          }
        })
      })
    },
    // 查询
    queryInfo() {
      this.form.page = 1
      this.getcheckinListList();
    },
    async getcheckinListList() {
      let searchForm = {
        ...this.form,
        bankCode:''
      }
      // 金融机构+信用办
      selectDemandListByCondition(searchForm).then(res=>{
        if(res.data.code == 200){
          this.applyProList = res.data.data.list;
          this.total = res.data.data.total;
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.getcheckinListList();
    },
    handleCurrentChange2(val) {
      this.form2.page = val;
      console.log(val)
      this.fanye();
    }
  },
};
</script>
<style lang='less' scoped>
.btn2{
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
.fkDialogClass{
  padding-left: 60px;
  .fkItem{
    display: flex;
    margin-bottom: 20px;
    align-items: center;
    font-size: 16px;
    .rightClass{
      margin-left: 10px;
    }
  }
}
.tab2 /deep/ .el-table th {
    background: #f3f4f9;
  }
.tab2 .block {
      margin-top: 20px;
      display: flex;
      justify-content: center;
    }
.content {
  min-height: 894px;
  margin-top: 10px;
  background-color: #fff;
  border-radius: 8px;
  padding-top: 10px;
  padding-bottom: 20px;
  width: 1050px;
  .top {
    height: 30px;
    border-left: 8px solid #2981ee;
    padding-left: 38px;
    box-sizing: border-box;
    font-size: 22px;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    color: #2981ee;
    line-height: 30px;
  }
  .from {
    margin-top: 37px;
    margin-left: 38px;
  }
  .dowm {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding-right: 40px;
    box-sizing: border-box;
    /deep/ .el-button {
      width: 157px;
      height: 40px;
      background: #2981ee;
      border-radius: 6px;
      color: #fff;
    }
  }
  .tab {
    box-sizing: border-box;
    margin-top: 15px;
    min-height: 700px;
    user-select: text;
    .block {
      margin-top: 20px;
      display: flex;
      justify-content: center;
    }
    /deep/ .el-table th {
      background: #f3f4f9;
    }
  }

}
</style> 